
export const fr = {
  // Common
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Register": "S'inscrire",
  "Search": "Rechercher",
  "Cart": "Panier",
  "Profile": "Profil",
  "Home": "Accueil",
  "Products": "Produits",
  "Categories": "Catégories",
  "Orders": "Commandes",
  "Settings": "Paramètres",
  "Continue": "Continuer",
  "Back": "Retour",
  "Save": "Enregistrer",
  "Cancel": "Annuler",
  "Submit": "Soumettre",
  "Delete": "Supprimer",
  "Edit": "Modifier",
  "Add": "Ajouter",
  "Remove": "Retirer",
  "Next": "Suivant",
  "Previous": "Précédent",
  "Loading": "Chargement...",
  "Error": "Erreur",
  "Success": "Succès",
  "Warning": "Avertissement",
  "Info": "Info",
  "Close": "Fermer",
  "Confirm": "Confirmer",
  "Yes": "Oui",
  "No": "Non",
  "Or": "Ou",
  "All": "Tout",
  "More": "Plus",
  "Less": "Moins",
  "Show more": "Afficher plus",
  "Show less": "Afficher moins",
  "Read more": "Lire plus",
  "Read less": "Lire moins",
  "See more": "Voir plus",
  "See less": "Voir moins",
  "View more": "Voir plus",
  "View less": "Voir moins",
  "Load more": "Charger plus",
  "Load less": "Charger moins",
  "Processing": "Traitement en cours...",
  "Sending": "Envoi en cours...",
  "Password": "Mot de passe",
  "Confirm Password": "Confirmer le mot de passe",
  "Email": "Email",
  "Username": "Nom d'utilisateur",
  "First Name": "Prénom",
  "Last Name": "Nom de famille",
  "Full Name": "Nom complet",
  "Address": "Adresse",
  "City": "Ville",
  "Country": "Pays",
  "State": "État/Province",
  "Zip Code": "Code postal",
  "Phone": "Téléphone",
  "Date": "Date",
  "Time": "Heure",
  "Price": "Prix",
  "Quantity": "Quantité",
  "Total": "Total",
  "Subtotal": "Sous-total",
  "Discount": "Remise",
  "Tax": "Taxe",
  "Shipping": "Livraison",
  "Payment": "Paiement",
  "Order": "Commande",
  "Order Number": "Numéro de commande",
  "Order Date": "Date de commande",
  "Order Status": "Statut de la commande",
  "Order Total": "Total de la commande",
  "Order Details": "Détails de la commande",
  "Order Items": "Articles de la commande",
  "Order History": "Historique des commandes",
  "New Order": "Nouvelle commande",
  "Cancel Order": "Annuler la commande",
  "Checkout": "Passer à la caisse",
  "Shipping Address": "Adresse de livraison",
  "Billing Address": "Adresse de facturation",
  "Payment Method": "Méthode de paiement",
  "Credit Card": "Carte de crédit",
  "PayPal": "PayPal",
  "Cash": "Espèces",
  "Mobile Money": "Argent Mobile",
  "Bank Transfer": "Virement bancaire",
  "Product": "Produit",
  "Product Name": "Nom du produit",
  "Product Description": "Description du produit",
  "Product Price": "Prix du produit",
  "Product Image": "Image du produit",
  "Product Category": "Catégorie du produit",
  "Product Brand": "Marque du produit",
  "Product Model": "Modèle du produit",
  "Product Color": "Couleur du produit",
  "Product Size": "Taille du produit",
  "Product Weight": "Poids du produit",
  "Product Availability": "Disponibilité du produit",
  "In Stock": "En stock",
  "Out of Stock": "Rupture de stock",
  "Add to Cart": "Ajouter au panier",
  "Remove from Cart": "Retirer du panier",
  "Wishlist": "Liste de souhaits",
  "Add to Wishlist": "Ajouter à la liste de souhaits",
  "Remove from Wishlist": "Retirer de la liste de souhaits",
  "Related Products": "Produits connexes",
  "Popular Products": "Produits populaires",
  "Featured Products": "Produits en vedette",
  "New Products": "Nouveaux produits",
  "Best Sellers": "Meilleures ventes",
  "Special Offers": "Offres spéciales",
  "Deals": "Promotions",
  "Sale": "Soldes",
  "Limited Time Offer": "Offre à durée limitée",
  "Free Shipping": "Livraison gratuite",
  "Express Shipping": "Livraison express",
  "Standard Shipping": "Livraison standard",
  "Delivery": "Livraison",
  "Delivery Time": "Délai de livraison",
  "Delivery Address": "Adresse de livraison",
  "Delivery Method": "Méthode de livraison",
  "Pickup": "Retrait",
  "Pickup Location": "Lieu de retrait",
  "Pickup Time": "Heure de retrait",
  "Return": "Retour",
  "Return Policy": "Politique de retour",
  "Refund": "Remboursement",
  "Refund Policy": "Politique de remboursement",
  "Exchange": "Échange",
  "Exchange Policy": "Politique d'échange",
  "Warranty": "Garantie",
  "Warranty Period": "Période de garantie",
  "Terms and Conditions": "Conditions générales",
  "Privacy Policy": "Politique de confidentialité",
  "FAQ": "FAQ",
  "Help": "Aide",
  "Support": "Support",
  "Contact": "Contact",
  "Contact Us": "Contactez-nous",
  "About": "À propos",
  "About Us": "À propos de nous",
  "Blog": "Blog",
  "News": "Actualités",
  "Events": "Événements",
  "Gallery": "Galerie",
  "Reviews": "Avis",
  "Testimonials": "Témoignages",
  "Rating": "Évaluation",
  "Comments": "Commentaires",
  "Share": "Partager",
  "Follow": "Suivre",
  "Like": "J'aime",
  "Social Media": "Réseaux sociaux",
  "Newsletter": "Bulletin d'information",
  "Subscribe": "S'abonner",
  "Unsubscribe": "Se désabonner",
  "Welcome": "Bienvenue",
  "Hello": "Bonjour",
  "Goodbye": "Au revoir",
  "Thank You": "Merci",
  "Sorry": "Désolé",
  "Congratulations": "Félicitations",
  "Confirm your email": "Confirmez votre email",
  "Forgot your password?": "Mot de passe oublié ?",
  "Reset Password": "Réinitialiser le mot de passe",
  "Create an account": "Créer un compte",
  "Already have an account?": "Vous avez déjà un compte ?",
  "Don't have an account?": "Vous n'avez pas de compte ?",
  "Sign In": "Se connecter",
  "Sign Up": "S'inscrire",
  "Sign Out": "Se déconnecter",
  "Remember Me": "Se souvenir de moi",
  "Stay Signed In": "Rester connecté",
  "Guest": "Invité",
  "Profile Picture": "Photo de profil",
  "Upload": "Télécharger",
  "Download": "Télécharger",
  "File": "Fichier",
  "Attachment": "Pièce jointe",
  "Image": "Image",
  "Video": "Vidéo",
  "Audio": "Audio",
  "Document": "Document",
  "Upload Failed": "Échec du téléchargement",
  "Download Failed": "Échec du téléchargement",
  "File Not Found": "Fichier non trouvé",
  "Invalid File": "Fichier invalide",
  "File Too Large": "Fichier trop volumineux",
  "Invalid File Type": "Type de fichier invalide",
  "Please Try Again": "Veuillez réessayer",
  "System Error": "Erreur système",
  "Network Error": "Erreur réseau",
  "Connection Error": "Erreur de connexion",
  "Server Error": "Erreur serveur",
  "Unknown Error": "Erreur inconnue",
  "Not Found": "Non trouvé",
  "Access Denied": "Accès refusé",
  "Permission Denied": "Permission refusée",
  "Unauthorized": "Non autorisé",
  "Forbidden": "Interdit",
  "Timeout": "Délai expiré",
  "Conflict": "Conflit",
  "Bad Request": "Mauvaise demande",
  "Invalid Request": "Demande invalide",
  "Invalid Response": "Réponse invalide",
  "Invalid Credentials": "Identifiants invalides",
  "Invalid Email": "Email invalide",
  "Invalid Password": "Mot de passe invalide",
  "Invalid Username": "Nom d'utilisateur invalide",
  "Invalid Phone Number": "Numéro de téléphone invalide",
  "Invalid Date": "Date invalide",
  "Invalid Time": "Heure invalide",
  "Invalid Format": "Format invalide",
  "Invalid Input": "Entrée invalide",
  "Required Field": "Champ obligatoire",
  "Field Required": "Champ obligatoire",
  "This field is required": "Ce champ est obligatoire",
  "Field Too Short": "Champ trop court",
  "Field Too Long": "Champ trop long",
  "Field Too Small": "Champ trop petit",
  "Field Too Large": "Champ trop grand",
  "Minimum Length": "Longueur minimale",
  "Maximum Length": "Longueur maximale",
  "Minimum Value": "Valeur minimale",
  "Maximum Value": "Valeur maximale",
  "Must match": "Doit correspondre",
  "Passwords do not match": "Les mots de passe ne correspondent pas",
  "Email already in use": "Email déjà utilisé",
  "Username already in use": "Nom d'utilisateur déjà utilisé",
  "Account already exists": "Le compte existe déjà",
  "Account not found": "Compte non trouvé",
  "User not found": "Utilisateur non trouvé",
  "Wrong password": "Mot de passe incorrect",
  "Too many attempts": "Trop de tentatives",
  "Try again later": "Réessayez plus tard",
  "Account locked": "Compte verrouillé",
  "Account disabled": "Compte désactivé",
  "Account expired": "Compte expiré",
  "Account suspended": "Compte suspendu",
  "Account deleted": "Compte supprimé",
  "Email not verified": "Email non vérifié",
  "Phone not verified": "Téléphone non vérifié",
  "Identity not verified": "Identité non vérifiée",
  "Verify your email": "Vérifiez votre email",
  "Verify your phone": "Vérifiez votre téléphone",
  "Verify your identity": "Vérifiez votre identité",
  "Verification code": "Code de vérification",
  "Enter verification code": "Entrez le code de vérification",
  "Code invalid": "Code invalide",
  "Code expired": "Code expiré",
  "Resend code": "Renvoyer le code",
  "Change email": "Changer d'email",
  "Change phone": "Changer de téléphone",
  "Change password": "Changer de mot de passe",
  "Current password": "Mot de passe actuel",
  "New password": "Nouveau mot de passe",
  "Confirm new password": "Confirmer le nouveau mot de passe",
  "Strong password": "Mot de passe fort",
  "Weak password": "Mot de passe faible",
  "Medium password": "Mot de passe moyen",
  "Password strength": "Force du mot de passe",
  "Password requirements": "Exigences du mot de passe",
  "Password must contain": "Le mot de passe doit contenir",
  "At least 8 characters": "Au moins 8 caractères",
  "At least one uppercase letter": "Au moins une lettre majuscule",
  "At least one lowercase letter": "Au moins une lettre minuscule",
  "At least one number": "Au moins un chiffre",
  "At least one special character": "Au moins un caractère spécial",
  "Dashboard": "Tableau de bord",
  "My Account": "Mon compte",
  "My Orders": "Mes commandes",
  "My Wishlist": "Ma liste de souhaits",
  "My Preferences": "Mes préférences",
  "My Downloads": "Mes téléchargements",
  "My Uploads": "Mes téléchargements",
  "My Tickets": "Mes tickets",
  "My Subscriptions": "Mes abonnements",
  "My Points": "Mes points",
  "My Coupons": "Mes coupons",
  "My Addresses": "Mes adresses",
  "My Payment Methods": "Mes méthodes de paiement",
  "My Notifications": "Mes notifications",
  "My Activity": "Mon activité",
  "Account Settings": "Paramètres du compte",
  "Email Notifications": "Notifications par email",
  "Push Notifications": "Notifications push",
  "SMS Notifications": "Notifications SMS",
  "Web Notifications": "Notifications web",
  "Notification Preferences": "Préférences de notification",
  "Language": "Langue",
  "Currency": "Devise",
  "Theme": "Thème",
  "Light Mode": "Mode clair",
  "Dark Mode": "Mode sombre",
  "System Default": "Par défaut du système",
  "Time Zone": "Fuseau horaire",
  "Calendar": "Calendrier",
  "Accessibility": "Accessibilité",
  "Display": "Affichage",
  "Sound": "Son",
  "Vibration": "Vibration",
  "Alerts": "Alertes",
  "Navigation": "Navigation",
  "Performance": "Performance",
  "Safety": "Sécurité",
  "Security": "Sécurité",
  "Manage access": "Gérer l'accès",
  "Two-factor authentication": "Authentification à deux facteurs",
  "Recovery": "Récupération",
  "Recovery email": "Email de récupération",
  "Recovery phone": "Téléphone de récupération",
  "Recovery methods": "Méthodes de récupération",
  "Backup": "Sauvegarde",
  "Backup Now": "Sauvegarder maintenant",
  "Last Backup": "Dernière sauvegarde",
  "Restore": "Restaurer",
  "Restore Defaults": "Restaurer les paramètres par défaut",
  "Restore From Backup": "Restaurer à partir d'une sauvegarde",
  "Delete Account": "Supprimer le compte",
  "Permanently Delete Account": "Supprimer définitivement le compte",
  "Delete Data": "Supprimer les données",
  "Delete All Data": "Supprimer toutes les données",
  "Are you sure?": "Êtes-vous sûr ?",
  "This action cannot be undone": "Cette action ne peut pas être annulée",
  "I understand the consequences": "Je comprends les conséquences",
  "Type your password to confirm": "Tapez votre mot de passe pour confirmer",
  "Save Changes": "Enregistrer les modifications",
  "Discard Changes": "Annuler les modifications",
  "Changes Saved": "Modifications enregistrées",
  "Could not save changes": "Impossible d'enregistrer les modifications",
  "Saving": "Enregistrement en cours...",
  "Updating": "Mise à jour en cours...",
  "Updated": "Mis à jour",
  "Failed to update": "Échec de la mise à jour",
  "Please wait": "Veuillez patienter",
  "Please wait a moment": "Veuillez patienter un moment",
  "Quick Actions": "Actions rapides",
  "More Actions": "Plus d'actions",
  "Recent": "Récent",
  "Recent Activity": "Activité récente",
  "Recent Orders": "Commandes récentes",
  "Recent Transactions": "Transactions récentes",
  "Top": "Haut",
  "Bottom": "Bas",
  "Left": "Gauche",
  "Right": "Droite",
  "Center": "Centre",
  "Middle": "Milieu",
  "Large": "Grand",
  "Medium": "Moyen",
  "Small": "Petit",
  "Start": "Début",
  "End": "Fin",
  "Now": "Maintenant",
  "Today": "Aujourd'hui",
  "Yesterday": "Hier",
  "Tomorrow": "Demain",
  "This Week": "Cette semaine",
  "Last Week": "Semaine dernière",
  "Next Week": "Semaine prochaine",
  "This Month": "Ce mois-ci",
  "Last Month": "Mois dernier",
  "Next Month": "Mois prochain",
  "This Year": "Cette année",
  "Last Year": "Année dernière",
  "Next Year": "Année prochaine",
  "Custom Range": "Plage personnalisée",
  "Filter": "Filtrer",
  "Sort": "Trier",
  "Sort By": "Trier par",
  "Filter By": "Filtrer par",
  "New": "Nouveau",
  "Old": "Ancien",
  "Newest First": "Plus récent d'abord",
  "Oldest First": "Plus ancien d'abord",
  "Price Low to High": "Prix croissant",
  "Price High to Low": "Prix décroissant",
  "Alphabetical (A-Z)": "Alphabétique (A-Z)",
  "Alphabetical (Z-A)": "Alphabétique (Z-A)",
  "Most Popular": "Plus populaire",
  "Most Reviewed": "Plus commenté",
  "Highest Rated": "Mieux noté",
  "Featured First": "En vedette d'abord",
  "Relevance": "Pertinence",
  "Distance": "Distance",
  "Nearest": "Plus proche",
  "Farthest": "Plus éloigné",
  "Ahavexer Portal": "Portail Ahavexer",
  "Manage your Ahavex business": "Gérez votre entreprise Ahavex",
  "Your Products": "Vos produits",
  "Manage your product inventory": "Gérez votre inventaire de produits",
  "No products found. Start adding products to your inventory.": "Aucun produit trouvé. Commencez à ajouter des produits à votre inventaire.",
  "Track and manage your orders": "Suivez et gérez vos commandes",
  "No orders found.": "Aucune commande trouvée.",
  "Manage your Ahavexer account settings": "Gérez les paramètres de votre compte Ahavexer",
  "Your account information and preferences": "Vos informations de compte et préférences",
  "Account Type": "Type de compte",
  "Ahavexer": "Ahavexer",
  "Ahavex ID": "ID Ahavex",
  "Phone Number": "Numéro de téléphone",
  "Last Updated": "Dernière mise à jour",
  "Profile Image": "Image de profil",
  "Update Profile Picture": "Mettre à jour la photo de profil",
  "Image size should be less than 3MB": "La taille de l'image doit être inférieure à 3 Mo",
  "Detailed Account Information": "Informations détaillées du compte",
  "Last Login": "Dernière connexion",
  "Created At": "Créé le",
  "Revenue": "Revenu",
  "Customers": "Clients",
  "Processing...": "Traitement en cours...",
  "Images will be compressed to 10% of original size": "Les images seront compressées à 10% de leur taille originale"
};
